import { Option } from './index';

export enum WorkType {
  icl = 'interactive checklist',
  exam = 'exam',
  hw = 'homework',
}

export enum ExamStatus {
  sended = 'sended', // sended to student
  started = 'started', // started working on examen by student
  readyToCheck = 'readyToCheck', // examen completed by student and ready to check by teacher
  checked = 'checked', // examen checked by teacher
  notStarted = 'notStarted', // examen not started by student
  completed = 'completed', // completed by student
}

export interface ICL {
  number: number;
  courseName: string;
  courseGoal: string;
  class: string;
  subject: Option;
  theme: string;
  language: string;
  id: string;
  createdAt: number;
  isTemplate: boolean;
  isActive: boolean;
  type: WorkType;
  parentId?: string;
  teacherEmail?: string;
  studentEmail?: string;
  isConsideration?: boolean;
  checked?: boolean;
  completed?: boolean;
  correction?: boolean;
  deleted?: boolean;
}

export interface HW {
  title: string;
  class: string;
  subject: Option;
  id: string;
  createdAt: number;
  isTemplate: boolean;
  isActive: boolean;
  type: WorkType;
  parentId?: string;
  teacherEmail?: string;
  studentEmail?: string;
  isConsideration?: boolean;
  checked?: boolean;
  completed?: boolean;
}

export interface Exam extends ICL {
  status?: ExamStatus;
  totalPoint?: number;
  time?: any;
}

export interface PersonOption {
  FIO: string;
  email: string;
}
